<template>

    <div class="n2-center-container" style="background-color:#fff; padding:10px; position: relative;">
        <h5>{{ $t('pages.forget_password.forget_password') }}</h5>
        <div style="max-width:600px;">
            <p>{{ $t('pages.forget_password.desc') }}</p>
            <form-input type="text" v-model="email" v-bind:label="$t('pages.forget_password.email')"
                v-bind:errors="model_errors.email"></form-input>
            <validation-summary v-bind:errors="model_errors"></validation-summary>
            <div class="n2-margin-top">
                <button class="n2-button-1" v-on:click="send">{{ $t('pages.forget_password.send') }}</button>
            </div>
            <div class="n2-margin-top">
                <result-summary v-bind:error="result_error"></result-summary>
            </div>
        </div>
        <h5 v-if="result == 'succeeded'">{{ $t('pages.forget_password.succeeded') }}</h5>
        <app-loader v-bind:active="loading"></app-loader>

    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { IdentityService } from '../services'
import AppLoader from '../components/shared/loader.vue'
import FormInput from "../components/shared/form-input.vue"
import ValidationSummary from '../components/shared/validation-summary.vue';
import ResultSummary from '../components/shared/result-summary.vue';


export default {
    components: {
        AppLoader, FormInput, ValidationSummary, ResultSummary
    },
    data: function () {
        return {
            model_errors: {},
            email: '',
            loading: false,
            result: '',
            result_error: ''
        }
    },
    computed: {
        ...mapGetters('identity', [
            'user',
        ]),
        ...mapGetters('globalization', [
            'app_locale',
            'locale'
        ])
    },

    created: function () {
        this.identityService = new IdentityService()

    },
    mounted: async function () {
    },
    methods: {
        validateForm: function () {
            this.model_errors = {}
            var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (!re.test(this.email)) {
                this.model_errors['email'] = [this.$t('pages.forget_password.error_email')]
            }

            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        send: async function () {
            this.result_error = '';

            if (!this.validateForm()) {
                return
            }
            try {
                this.loading = true;
                await this.identityService.sendPasswordResetEmail({ email: this.email, app_locale: this.app_locale, locale: this.locale })
                this.result = 'succeeded'
                this.model = {}
            }
            catch (err) {
                if (err.errors && err.errors.current_password) {
                    this.$set(this.model_errors, 'current_password', [this.$t('pages.forget_password.error_worng_current_password')])
                }
                else {
                    this.result_error = this.$t('pages.forget_password.failed')
                }
            }
            finally {
                this.loading = false;
            }
        }
    }
}
</script>
